import EgyFlag from "../Icons/EgyFlag";
import EnvelopeIcon from "../Icons/EnvelopeIcon";
import LocationIcon from "../Icons/LocationIcon";
import NedFlag from "../Icons/NedFlag";
import PhoneIcon from "../Icons/PhoneIcon";
import UkFlag from "../Icons/UkFlag";

export const REACT_APP_API_ENDPOINT = "http://localhost:8080/";

export const appPagesSections = [
  {
    name: "Home",
    url: "/home",
    sections: [
      { name: "What we offer", id: "landing" },
      { name: "Featured collection", id: "featured-collection" },
      { name: "Who we are", id: "who-we-are" },
      { name: "Our process", id: "company-process" },
      { name: "Join us", id: "join-us" },
    ],
  },
  {
    name: "Shop",
    url: "/shop",
    sections: [
      { name: "Visit our Shop", id: "visit-our-shop" },
      { name: "Our feature products", id: "featured-selction" },
      { name: "On Sale", id: "on-sale" },
    ],
  },
  {
    name: "About us",
    url: "/about-us",
    sections: [
      { name: "Who we are", id: "who-we-are" },
      { name: "Our History", id: "our-history" },
      { name: "Our Values", id: "our-values" },
      { name: "Testimonials", id: "testimonials" },
      { name: "Why Choose us", id: "why-choose-us" },
    ],
  },
  {
    name: "Contact us",
    url: "/contact-us",
    sections: [
      {
        name: "Our Locations",
        id: "our-locations",
        icon: <LocationIcon />,
      },
      {
        name: "Phonenumber",
        id: "phonenumber",
        icon: <PhoneIcon />,
      },
      {
        name: "Email",
        id: "email",
        icon: <EnvelopeIcon />,
      },
      { name: "Contact form", id: "contact-form" },
    ],
  },
];

export const locations = [
  {
    type: "Netherlands",
    flag: <NedFlag />,
    address: `Steetname 101B,
    1000 AA, Naaldwijk,
    The Netherlands`,
  },
  {
    type: "Egypt",
    flag: <EgyFlag />,
    address: `101 Steetname,
    Cairo, Egypt`,
  },
  {
    type: "United Kingdom",
    flag: <UkFlag />,
    address: `101B Steetname,
  AA99 5EX, London,
  United Kingdom`,
  },
];

export const countryMapping = [
  { name: "Netherlands", countryCode: "NL", countryCode3: "NLD" },
  { name: "Egypt", countryCode: "EG", countryCode3: "EGY" },
  { name: "United Kingdom", countryCode: "GB", countryCode3: "GBR" },
];

export const sortByOptions = [
  "Relevance",
  "Best Sellers",
  "Price: High-Low",
  "Price: Low-High",
];
export const shopFilters = [
  {
    name: "Sort By",
    options: sortByOptions,
    value: "Relevance",
    type: "sorting",
    onChangeHandler: "handleInputChange",
  },
  {
    name: "Categories",
    productAtt: "category",
    type: "selection",
    selections: [
      {
        name: "Cut Flowers",
        selected: false,
        disabled: false,
      },
      {
        name: "Home Plants",
        selected: false,
        disabled: false,
      },
      {
        name: "Seeds",
        selected: false,
        disabled: false,
      },
      {
        name: "Accessories",
        selected: false,
        disabled: false,
      },
    ],
  },
  {
    name: "Type/Genus",
    productAtt: "genus",
    type: "selection",
    selections: [
      {
        name: "Hydrangea",
        selected: false,
        disabled: false,
      },
      {
        name: "Rosa",
        selected: false,
        disabled: false,
      },
      {
        name: "Dianthus",
        selected: false,
        disabled: false,
      },
      {
        name: "Cymbidium",
        selected: false,
        disabled: false,
      },
      {
        name: "Tulipa",
        selected: false,
        disabled: false,
      },
      {
        name: "Alstroemeria",
        selected: false,
        disabled: false,
      },
    ],
  },
  {
    name: "Color",
    productAtt: "color",
    type: "selection",
    selections: [
      {
        name: "red",
        selected: false,
        disabled: false,
      },
      {
        name: "yellow",
        selected: false,
        disabled: false,
      },
      {
        name: "blue",
        selected: false,
        disabled: false,
      },
      {
        name: "orange",
        selected: false,
        disabled: false,
      },
      {
        name: "green",
        selected: false,
        disabled: false,
      },
      {
        name: "purple",
        selected: false,
        disabled: false,
      },
      {
        name: "brown",
        selected: false,
        disabled: false,
      },
      {
        name: "pink",
        selected: false,
        disabled: false,
      },
      {
        name: "white",
        selected: false,
        disabled: false,
      },
      {
        name: "grey",
        selected: false,
        disabled: false,
      },
      {
        name: "black",
        selected: false,
        disabled: false,
      },
    ],
  },
  {
    name: "Origin country",
    productAtt: "country_of_origin",
    type: "selection",
    values: ["Netherland", "Kenya", "Ecuador"],
    selectedValues: [],
    disabled: [],
  },
  // {
  //   title: "Price",
  //   type: "range",
  //   min: 0,
  //   maxValue: 100,
  //   filteredValues:100,
  // },
  {
    name: "Height/Length",
    productAtt: "length",
    type: "range",
    min: 0,
    maxValue: 0,
    minValue: 0,
    max: 0,
  },
];

// export const productsSample = [
//   {
//     Application: "Houseplants",
//     "Product code": 655,
//     "Product name": "Hydrangea macrophylla 'Blauer Zwerg'",
//     "Product abbreviation": "HYDR M BLAUER ZWERG",
//     Registrator: "Floricode",
//     "Registration Code": 106577,
//     "Product image": flowerBlauwB,
//     "Main color flower": "blue",
//     "RHS main color flower": "100B",
//     "Selling units": "per item",
//     Availability: "[A, M]",
//     "Genus (type)": "Hydrangea",
//     "Cultivar (variant)": "Blauer Zwerg",
//     Group: "Hydrangea macrophylla",
//     "Group code": 20203601,
//     Color: "100B",
//     "Flower type": "Single",
//     "Flower color": "Blue-medium blue-100C",
//     "Petal edge": "",
//     "Leaf shape": "Oval / elliptic",
//     "Flower diameter": "3.4 - 4 cm",
//     "Flower height": "",
//     "Plant height": "10 - 15 cm",
//     minHeight: 10,
//     maxHeight: 15,
//     "Leaf size": "10 -15 cm",
//     Inflorescence: "",
//     "soil PH req.":
//       "Slightly acidic (pH 4.5 - 6.5), \nAlkaline (pH > 7.5), \nNeutral (pH 6.5 - 7.5)",
//     "Light conditions": "Sunny; Semi-shades",
//     "Leaf color": "Dark green",
//     "Flower scent": "",
//     "Lip color": "",
//     "Flower color dist": "",
//   },
//   {
//     Application: "Cut flowers",
//     "Product code": 130309,
//     "Product name": "Rosa large flowered Renaissance",
//     "Product abbreviation": "R GR RENAISSANCE",
//     Registrator: "Floricode",
//     "Registration Code": 283770,
//     "Product image": flower130309,
//     "Main color flower": "pink",
//     "RHS main color flower": "073B",
//     "Selling units": "per item",
//     Availability: "[M]",
//     "Genus (type)": "Rosa",
//     "Cultivar (variant)": "Tan16142",
//     Group: "Rosa large flowered",
//     "Group code": 10100101,
//     Color: "073B",
//     "Flower type": "Double (pleniflorous)",
//     "Flower color": "",
//     "Petal edge": "Pink-medium blue pink-073B",
//     "Leaf shape": "",
//     "Flower diameter": "8 - 8.5 cm",
//     "Flower height": "4 - 4.5 cm",
//     minHeight: 4,
//     maxHeight: 4.5,
//     "Plant height": "",
//     "Leaf size": "",
//     Inflorescence: "Single-flowered",
//     "soil PH req.": "",
//     "Light conditions": "",
//     "Leaf color": "Dark green",
//     "Flower scent": "",
//     "Lip color": "",
//     "Flower color dist": "Unicolored",
//   },
//   {
//     Application: "Cut flowers",
//     "Product code": 130310,
//     "Product name": "Rosa large flowered Boardwalk",
//     "Product abbreviation": "R GR BOARDWALK",
//     Registrator: "Floricode",
//     "Registration Code": 283771,
//     "Product image": flower130310,
//     "Main color flower": "orange",
//     "RHS main color flower": "026A",
//     "Selling units": "per item",
//     Availability: "[M]",
//     "Genus (type)": "Rosa",
//     "Cultivar (variant)": "IPK347915",
//     Group: "Rosa large flowered",
//     "Group code": 10100101,
//     Color: "026A",
//     "Flower type": "Double (pleniflorous)",
//     "Flower color": "Orange-medium orange-026A",
//     "Petal edge": "",
//     "Leaf shape": "",
//     "Flower diameter": "8 - 8.5 cm",
//     "Flower height": "4 - 4.5 cm",
//     minHeight: 4,
//     maxHeight: 4.5,
//     "Plant height": "",
//     "Leaf size": "",
//     Inflorescence: "Single-flowered",
//     "soil PH req.": "",
//     "Light conditions": "",
//     "Leaf color": "Dark green",
//     "Flower scent": "",
//     "Lip color": "",
//     "Flower color dist": "With trace; \nMulti-colored",
//   },
//   {
//     Application: "Houseplants",
//     "Product code": 130311,
//     "Product name": "Euphorbia pulcherrima Qismas Bond",
//     "Product abbreviation": "EUPHOR P QISMAS BOND",
//     Registrator: "Floricode",
//     "Registration Code": 283772,
//     "Product image": flower130311,
//     "Main color flower": "red",
//     "RHS main color flower": "N045B",
//     "Selling units": "per item",
//     Availability: "[N , D]",
//     "Genus (type)": "",
//     "Cultivar (variant)": "",
//     Group: "Euphorbia pulcherrima",
//     "Group code": 20201001,
//     Color: "N045B",
//     "Flower type": "",
//     "Flower color": "",
//     "Petal edge": "",
//     "Leaf shape": "",
//     "Flower diameter": "",
//     "Flower height": "",
//     minHeight: 0,
//     maxHeight: 0,
//     "Plant height": "",
//     "Leaf size": "",
//     Inflorescence: "",
//     "soil PH req.": "",
//     "Light conditions": "",
//     "Leaf color": "",
//     "Flower scent": "",
//     "Lip color": "",
//     "Flower color dist": "",
//   },
//   {
//     Application: "Cut flowers",
//     "Product code": 130312,
//     "Product name": "Dianthus spray Sommelier",
//     "Product abbreviation": "DI TR SOMMELIER",
//     Registrator: "Floricode",
//     "Registration Code": 283774,
//     "Main color flower": "purple",
//     "RHS main color flower": "N077C",
//     "Product image": flower130312,
//     "Selling units": "per item",
//     Availability: "[M]",
//     "Genus (type)": "Dianthus",
//     "Cultivar (variant)": "Kled01v20",
//     Group: "Dianthus spray",
//     "Group code": 10100201,
//     Color: "[N077C, N066B]",
//     "Flower type": "Double (pleniflorous)",
//     "Flower color": "Purple-dark violet-N077C;\nPind-medium purple red-N066B",
//     "Petal edge": "Sinuate",
//     "Leaf shape": "",
//     "Flower diameter": "5.5 - 6 cm",
//     "Flower height": "4.5 - 5 cm",
//     minHeight: 4.5,
//     maxHeight: 5,
//     "Plant height": "",
//     "Leaf size": "",
//     Inflorescence: "Raceme",
//     "soil PH req.": "",
//     "Light conditions": "",
//     "Leaf color": "Green gray",
//     "Flower scent": "",
//     "Lip color": "",
//     "Flower color dist": "With trace; \nBicolored",
//   },
//   {
//     Application: "Houseplants",
//     "Product code": 130301,
//     "Product name": "Cymbidium 'Indian Summer'",
//     "Product abbreviation": "CYMB INDIAN SUMMER",
//     Registrator: "Floricode",
//     "Registration Code": 283718,
//     "Main color flower": "brown",
//     "RHS main color flower": "164A",
//     "Product image": flower130301,
//     "Selling units": "per item",
//     Availability: "",
//     "Genus (type)": "Cymbidium",
//     "Cultivar (variant)": "Indian Summer",
//     Group: "Cymbidium",
//     "Group code": 20910701,
//     Color: "[164A, 185A]",
//     "Flower type": "",
//     "Flower color": "Brown-light brown-164A;\nRed-dark purple red-185A",
//     "Petal edge": "",
//     "Leaf shape": "Linear",
//     "Flower diameter": "5 - 5.5 cm",
//     "Flower height": "",
//     minHeight: 0,
//     maxHeight: 0,
//     "Plant height": "",
//     "Leaf size": "",
//     Inflorescence: "Raceme",
//     "soil PH req.": "",
//     "Light conditions": "",
//     "Leaf color": "Dark green",
//     "Flower scent": "",
//     "Lip color": "Red-dark purple red-059A",
//     "Flower color dist": "Striate;\nDotted;\nMulti-colored",
//   },
//   {
//     Application: "Cut flowers",
//     "Product code": 130251,
//     "Product name": "Dianthus standard 'Teide'",
//     "Product abbreviation": "DI ST TEIDE",
//     Registrator: "Floricode",
//     "Registration Code": 283610,
//     "Main color flower": "red",
//     "RHS main color flower": "043A",
//     "Product image": flower130251,
//     "Selling units": "per item",
//     Availability: "",
//     "Genus (type)": "Dianthus",
//     "Cultivar (variant)": "Teide",
//     Group: "Dianthus standard",
//     "Group code": 10100202,
//     Color: "",
//     "Flower type": "Double (pleniflorous)",
//     "Flower color": "Red-medium red-043A",
//     "Petal edge": "Serrate",
//     "Leaf shape": "Linear",
//     "Flower diameter": "4.5 - 5 cm",
//     "Flower height": "7 - 7.5 cm",
//     minHeight: 7,
//     maxHeight: 7.5,
//     "Plant height": "",
//     "Leaf size": "",
//     Inflorescence: "Single-flowered",
//     "soil PH req.": "",
//     "Light conditions": "",
//     "Leaf color": "Green grey",
//     "Flower scent": "",
//     "Lip color": "",
//     "Flower color dist": "Unicolored",
//   },
//   {
//     Application: "Cut flowers",
//     "Product code": 130289,
//     "Product name": "Tulipa (Triump Grp) 'Twizzle'",
//     "Product abbreviation": "TU EN TWIZZLE",
//     Registrator: "Floricode",
//     "Registration Code": 281648,
//     "Main color flower": "red",
//     // "RHS main color flower": ["N045B","009A"],
//     "RHS main color flower": "009A",
//     "Product image": flower130289,
//     "Selling units": "per item",
//     Availability: "",
//     "Genus (type)": "Tulipa",
//     "Cultivar (variant)": "Twizzle",
//     Group: "Tulipa",
//     "Group code": 10301101,
//     Color: "",
//     "Flower type": "Single",
//     "Flower color": "Yellow-medium yellow-0094; Red-dark red-N045B",
//     "Petal edge": "Serrate",
//     "Leaf shape": "Linear",
//     "Flower diameter": "",
//     "Flower height": "5 - 5.5 cm",
//     minHeight: 5,
//     maxHeight: 5.5,
//     "Plant height": "",
//     "Leaf size": "",
//     Inflorescence: "",
//     "soil PH req.": "",
//     "Light conditions": "",
//     "Leaf color": "",
//     "Flower scent": "",
//     "Lip color": "",
//     "Flower color dist": "Bicolored",
//   },
//   {
//     Application: "Cut flowers",
//     "Product code": 129206,
//     "Product name": "Tulipa (Triumph Grp) 'Wifi'",
//     "Product abbreviation": "TU EN WIFI",
//     Registrator: "Floricode",
//     "Registration Code": 281673,
//     "Main color flower": "red",
//     // "RHS main color flower": ["N045B","009A"],
//     "RHS main color flower": "060D",
//     "Product image": flower129206,
//     "Selling units": "per item",
//     Availability: "",
//     "Genus (type)": "Tulipa",
//     "Cultivar (variant)": "Twizzle",
//     Group: "Tulipa",
//     "Group code": 10301101,
//     Color: "",
//     "Flower type": "Single",
//     "Flower color": "Pink-medium purple-060D",
//     "Petal edge": "Serrate",
//     "Leaf shape": "Linear",
//     "Flower diameter": "",
//     "Flower height": "5.5 - 6 cm",
//     minHeight: 5.5,
//     maxHeight: 6,
//     "Plant height": "",
//     "Leaf size": "",
//     Inflorescence: "",
//     "soil PH req.": "",
//     "Light conditions": "",
//     "Leaf color": "",
//     "Flower scent": "",
//     "Lip color": "",
//     "Flower color dist": "Unicolored",
//   },
//   {
//     Application: "Cut flowers",
//     "Product code": 130145,
//     "Product name": "Alstroemeria Freeze",
//     "Product abbreviation": "ALSTR FREEZE",
//     Registrator: "Floricode",
//     "Registration Code": 283395,
//     "Main color flower": "white",
//     // "RHS main color flower": ["N045B","009A"],
//     "RHS main color flower": "NN155D",
//     "Product image": flower130145,
//     "Selling units": "per item",
//     Availability: "",
//     "Genus (type)": "Alstroemeria",
//     "Cultivar (variant)": "Tesfreeze",
//     Group: "Alstroemeria",
//     "Group code": 10100301,
//     Color: "",
//     "Flower type": "",
//     "Flower color": "White-white-NN155D",
//     "Petal edge": "",
//     "Leaf shape": "",
//     "Flower diameter": "6 - 6.5 cm",
//     "Flower height": "6.5 - 7 cm",
//     minHeight: 6.5,
//     maxHeight: 7,
//     "Plant height": "",
//     "Leaf size": "",
//     Inflorescence: "",
//     "soil PH req.": "",
//     "Light conditions": "",
//     "Leaf color": "Dark green",
//     "Flower scent": "",
//     "Lip color": "",
//     "Flower color dist": "Unicolored with trace; Striate",
//   },
// ];
